import { ComponentProps, JSX } from "solid-js";
import c from "class-c";

import styles from "./ModalSheet.module.scss";

declare namespace ModalSheet {
  interface Props {
    class?: string;
    children: JSX.Element;
  }
}

function ModalSheet({ class: className, children }: D<ModalSheet.Props>) {
  return (
    <div class={c`${styles["hybrid-modal"]} ${className}`}>{children}</div>
  );
}

declare namespace ModalSheet.EscapePaddingX {
  type Props = ComponentProps<"div">;
}

ModalSheet.EscapePaddingX = ({
  children,
  class: className,
  ...props
}: D<ModalSheet.EscapePaddingX.Props>) => {
  return (
    <div class={c`${styles["escape-padding-x"]} ${className}`} {...props}>
      {children}
    </div>
  );
};

export default ModalSheet;
